import * as Sentry from '@sentry/react';

export function initSentry() {
  const dsn = process.env.REACT_APP_SENTRY_DSN;
  if (!dsn) return;

  Sentry.init({
    dsn,
    environment: process.env.NODE_ENV,
    enabled: process.env.NODE_ENV === 'production',
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0.1,
    beforeSend(event) {
      // Scrub any license plate data from error reports
      if (event.request?.data) {
        const data = event.request.data;
        if (typeof data === 'string' && data.includes('plate')) {
          event.request.data = '[Redacted]';
        }
      }
      return event;
    },
  });
}

export { Sentry };
